/* eslint-disable react/prop-types */
import React from 'react';
import { Heading } from 'Components/molecules/Heading';
import { getTaxonomyFilter } from 'SharedPartials/getTaxonomyFilter';

export const getIndexArticlePageHeader = ({
  indexData,
  propsData,
  showFilters = false,
  taxonomyFilterParams,
  greyBg = true,
}) => {
  const {
    pagination: {
      pages,
      page: currPage,
    },
  } = propsData;

  if (!Array.isArray(pages[currPage]) || !pages[currPage].length) {
    return false;
  }

  return (
    <>
      <div className="polaris__article-group--header">
        <div className="polaris__article-group--block">
          <Heading size={4} extraClassNames={{ 'polaris__article-group--title': true }}>{indexData.title ? `More on ${indexData.title}` : 'More like this'}</Heading>
        </div>
      </div>
      {showFilters && (
        greyBg ? (
          <div className="polaris__gray--bg">
            {getTaxonomyFilter(taxonomyFilterParams)}
          </div>
        ) : (
          getTaxonomyFilter(taxonomyFilterParams)
        )
      )}
    </>
  );
};
